import type {NewFacetsLogicConfig} from '../../../strategies/types/facets-config-strategy-data.type';

export const DEFAULT_FACET_LOGIC_CONFIG_CONSTANT: NewFacetsLogicConfig = {
  showChildren: 'whenParentSelected',
  showChips: false,
  filtersCollapseLimit: 5,
  showFiltersSearchInput: false
};
